
export const CoachRecommendationView = ({ recommendation }) => {
  // Check if recommendation exists
  if (!recommendation) {
    return (
      <div className="rounded-2xl border-jp-line">
        <h2 className="text-lg font-extrabold text-jp-ink mb-4">Coach Recommendation</h2>
        <div className="p-6 rounded-xl bg-jp-section border border-jp-line text-center">
          <p className="text-jp-muted text-sm">No coach recommendation available</p>
        </div>
      </div>
    );
  }

  return (
    <div className="rounded-2xl border-jp-line">
      <h2 className="text-lg font-extrabold text-jp-ink mb-4">Coach Recommendation</h2>


      <div className="p-6 rounded-xl bg-jp-section border border-jp-line">
      </div>

    </div>
  );
};

export default CoachRecommendationView;
